<div class="period-detail">
  <div class="summary">
    <span class="status-badge" [class.closed]="IsClosed">{{ Period.Status }}</span>
    <span>{{ Period.StartDate | date:'MM/dd/yyyy':'UTC' }} – {{ Period.EndDate | date:'MM/dd/yyyy':'UTC' }}</span>
    <span class="muted">{{ Period.OpenJournals || 0 }} draft or in-review journal(s)</span>
  </div>

  <div class="actions">
    @if (CanManage) {
    <button mat-button [class]="IsClosed ? 'btn-bg-green' : 'btn-bg-red'" [disabled]="Busy" (click)="changeStatus()">
      {{ IsClosed ? 'Reopen period' : 'Close period' }}
    </button>
    } @else {
    <span class="muted">Only period owners can close or reopen periods.</span>
    }
    <span class="spacer"></span>
    <button mat-button (click)="close()">Close</button>
  </div>

  <fieldset class="rms-fieldset">
    <legend>History</legend>
    @if (Loading) {
    <p class="muted" role="status">Loading history…</p>
    } @else if (!History.length) {
    <p class="muted">This period has never been closed or reopened.</p>
    } @else {
    <ul class="history">
      @for (h of History; track h.PeriodHistoryID) {
      <li>
        <span class="when">{{ h.ActionDate | date:'MM/dd/yyyy h:mm a' }}</span>
        <strong>{{ h.ActionType }}</strong>
        <span>{{ h.BeforeStatus }} → {{ h.AfterStatus }}</span>
        <span class="reason">"{{ h.Reason }}"</span>
        <span class="who">by {{ h.ActionByName || 'unknown' }}</span>
      </li>
      }
    </ul>
    }
  </fieldset>
</div>
